import {
  Button,
  Divider,
  Flex,
  Group,
  Modal,
  Stack,
  Text,
} from '@mantine/core';

interface ConfirmChargeAmountDialogProps {
  opened: boolean;
  amount: number;
  handlingFee?: number;
  subtitle?: string;
  loading?: boolean;
  onBack: () => void;
  onConfirm: () => void;
}

export function ConfirmChargeAmountDialog({
  opened,
  amount,
  handlingFee,
  subtitle,
  loading,
  onBack,
  onConfirm,
}: ConfirmChargeAmountDialogProps) {
  const hasHandlingFee = handlingFee != null;
  const total = amount + (handlingFee ?? 0);

  return (
    <Modal
      opened={opened}
      onClose={onBack}
      zIndex={300}
      title={
        <Stack gap={2}>
          <Text fw={600} size="lg">
            確認請款金額
          </Text>
          {subtitle && (
            <Text size="sm" c="dimmed">
              {subtitle}
            </Text>
          )}
        </Stack>
      }
      size="lg"
    >
      <Stack gap="md">
        <Text size="sm" c="dimmed">
          請確認以下金額無誤，送出後系統會即時向用戶發起請款。
        </Text>

        <Flex
          bg={'rgb(248, 249, 250)'}
          bdrs="lg"
          p="lg"
          direction="column"
          gap="sm"
        >
          <Group justify="space-between">
            <Text size="sm" c="dimmed">
              線上代繳金額
            </Text>
            <Text size="sm" fw={500}>
              {`NT$ ${amount}`}
            </Text>
          </Group>

          {hasHandlingFee && (
            <Group justify="space-between">
              <Text size="sm" c="dimmed">
                手續費
              </Text>
              <Text size="sm" fw={500}>
                {`NT$ ${handlingFee}`}
              </Text>
            </Group>
          )}

          <Divider />

          <Group justify="space-between" align="center">
            <Text size="sm" fw={500}>
              合計
            </Text>
            <Text size="24px" fw={700}>
              {`NT$ ${total}`}
            </Text>
          </Group>
        </Flex>

        <Group justify="flex-end" mt="xs">
          <Button variant="default" onClick={onBack} disabled={loading}>
            返回
          </Button>
          <Button onClick={onConfirm} loading={loading}>
            確認送出請款
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
